<app-page-title title="Setor"></app-page-title>
<h3><label>Nome: &nbsp;</label>{{ sector?.name }}</h3>
<h3><label>Lider: &nbsp;</label>{{ sector?.leader?.name }}</h3>
<h3><label>Área: &nbsp;</label>{{ sector?.area?.description }}</h3>

<button class="btn-back" mat-raised-button [routerLink]="['/setor']">&nbsp;&nbsp; Voltar</button>
